var ScrollSpyManager = function () {

    "use strict";

    var self = this;
    this.activeElement;
    this.spyEnabled = true;
    this.enabledScrollSpy = true;
    this.containerPosition;


    this.initialize = function () {
        this.eventDelegation();
        if (this.enabledScrollSpy) {
            $('[data-entity="table-scrollable"]').on("scroll", () => {
                this.checkPositionOffsetScrollSpy();
                myApp.scrollSpyManager.spy(self.containerPosition);
            });

            $(window).on("scroll", () => {
                this.checkPositionOffsetScrollSpy();
                myApp.scrollSpyManager.spy(self.containerPosition);
            });
        }
    };

    this.eventDelegation = function () {
        $('body').on('click', '[data-scrollspyarrow]', function () {
            if (!$(this).hasClass('disabled')) {
                var move = $(this).data('scrollspyarrow');
                self.goToHeaderElement(move, 'click');
            }
        });
        $('body').on('click', '[data-scrollspyelem=headerelem]', function () {
            self.toggleNextArrow($(this));
            self.togglePrevArrow($(this));

            self.goToSelectedHeaderElem($(this), $('[data-entity=table-scrollable]'), '#' + $(this).attr('data-scrollelem'));
        });
    };

    this.toggleNextArrow = function (clickedElem) {
        var last = $("[data-element=last]");

        if (clickedElem.is(last)) {
            $('[data-scrollspyarrow=next]').addClass('disabled');
        } else if ($('[data-scrollspyarrow=next]').hasClass('disabled')) {
            $('[data-scrollspyarrow=next]').removeClass('disabled');
        }
    };

    this.togglePrevArrow = function (clickedElem) {
        var first = $("[data-element=first]");

        if (clickedElem.is(first)) {
            $('[data-scrollspyarrow=prev]').addClass('disabled');
        } else if ($('[data-scrollspyarrow=prev]').hasClass('disabled')) {
            $('[data-scrollspyarrow=prev]').removeClass('disabled');
        }
    };

    this.goToSelectedHeaderElem = function (headerElem, container, element) {
        self.spyEnabled = false;
        self.activateHeaderElement(headerElem);
        myApp.scrollManager.scrollOn(container, element);
    };

    this.spy = function (position) {
        if (this.spyEnabled) {
            const lastSpiedElement = this.getLastSpiedElement(position, $('[data-entity=table-header]'));
            const $currentActiveHeader = $(".header-element.active");
            const $headerToActivate = $('[data-scrollelem=' + $(lastSpiedElement).attr("id") + ']');

            myApp.scrollSpyManager.activeElement = lastSpiedElement;

            if ($(lastSpiedElement) && !$currentActiveHeader.is($headerToActivate)) {
                this.defineHeaderMovement($(lastSpiedElement), $currentActiveHeader);
                self.activateHeaderElement($headerToActivate);
            }
        }
        this.spyEnabled = true;
    };

    this.checkPositionOffsetScrollSpy = function () {
        let datesTable = $('[data-entity=table-scrollable]');
        if (datesTable.length > 0 && myApp.scrollManager.isScrollable(datesTable)) {
            self.containerPosition = datesTable.offset().top + 5;
        } else {
            self.containerPosition = $(window).scrollTop() + 120;
        }
    };

    this.getLastSpiedElement = function (position, elem) {
        var element = $(elem).first();
        elem.each(function (index) {
            if ($(this).offset().top <= position) {
                element = $(this);
            }
        });
        return element;
    };

    this.defineHeaderMovement = function (elem, $currentActiveHeader) {
        const $headerElem = $(`[data-scrollelem=${elem.attr('id')}]`);

        const tabs = $('.header-element').slice(1, -1);
        const directonSteps = tabs.index($headerElem) - tabs.index($currentActiveHeader);

        for (let i = 0; i < Math.abs(directonSteps); i++) {
            directonSteps > 0 ? this.goToNextHeaderElement('scroll') : this.goToPreviousHeaderElement('scroll');
        }
    };

    this.goToHeaderElement = function (movement, activator) {
        if (movement == 'next') {
            this.goToNextHeaderElement(activator);
        } else if (movement == 'prev') {
            this.goToPreviousHeaderElement(activator);
        }
    };

    this.goToNextHeaderElement = function (activator) {
        var currentLast =  $("[data-position=last]");
        var nextToShow = currentLast.next();
        var prev = $("[data-position=first]");
        var last = $("[data-element=last]");
        var active = $(".header-element.active");

        if (nextToShow.length > 0 && (typeof prev.next().data('scrollspyarrow') == "undefined") && (typeof nextToShow.data('scrollspyarrow') == "undefined")) {
            this.hideHeaderElement(prev);
            prev.next().attr('data-position', 'first');
            this.showHeaderElement(nextToShow, currentLast, 'last', $('[data-scrollspyarrow=prev]'));
            if (activator === 'click') {
                self.goToSelectedHeaderElem(active.next(), '[data-entity=table-scrollable]', '#' + active.next().data('scrollelem'));
            }
        } else if (currentLast.is(last) && activator === 'click') {
            self.goToSelectedHeaderElem(active.next(), '[data-entity=table-scrollable]', "#" + active.next().data('scrollelem'));
        }

        if (active.next().is(last) || nextToShow.data('scrollspyarrow') === 'next') {
            $('[data-scrollspyarrow=next]').addClass('disabled');
        }
    };

    this.goToPreviousHeaderElement = function (activator) {
        var currentFirst = $("[data-position=first]");
        var nextToShow = currentFirst.prev();
        var nextToHide = $("[data-position=last]");
        var first = $("[data-element=first]");
        var active = $(".header-element.active");

        if (nextToShow.length > 0 && (typeof nextToShow.data('scrollspyarrow') == "undefined") && (typeof nextToHide.data('scrollspyarrow') == "undefined")) {
            this.hideHeaderElement(nextToHide);
            nextToHide.prev().attr('data-position', 'last');
            this.showHeaderElement(nextToShow, currentFirst, 'first', $('[data-scrollspyarrow=next]'));
            if (activator === 'click') {
                self.goToSelectedHeaderElem(active.prev(), '[data-entity=table-scrollable]', '#' + active.prev().data('scrollelem'));
            }
        } else if (currentFirst.is(first) && activator === 'click') {
            self.goToSelectedHeaderElem(active.prev(), '[data-entity=table-scrollable]', "#" + active.prev().data('scrollelem'));
        }

        if (active.prev().is(first) || nextToShow.data('scrollspyarrow') === 'prev') {
            $('[data-scrollspyarrow=prev]').addClass('disabled');
        }
    };

    this.showHeaderElement = function (elem, flag, label, arrow) {
        flag.attr('data-position', '');
        elem.show();
        elem.attr('data-position', label);
        arrow.removeClass('disabled');
    };

    this.hideHeaderElement = function (elem) {
        elem.hide();
        elem.attr('data-position', '');
    };

    this.activateHeaderElement = function (elem) {
        myApp.domManager.toggleClass(elem, $('[data-scrollelem]'), 'active');
        myApp.domManager.toggleClass(elem.find('[data-hidescrollspy]'), $('[data-hidescrollspy]'), 'hidden');
    };
    this.initialize();
};

export default ScrollSpyManager;
